export default "__VITE_ASSET__2bef3916__"